import React from 'react'
import { CompanyLogo, FooterContainer, FooterWrapperMain, PrivacyLink, PrivacyText, RightSideFooter } from './style'
import { FooterLogo } from '../../../assets/images/icons'
import { TourGuide } from '../../../components'
import { useGlobalStore } from '../../../store'

const Footer = ({ notMainPage = true }) => {

  const { isTourGuideActive } = useGlobalStore();
  return (
    <FooterWrapperMain>
    <FooterContainer>
      <PrivacyText>
        <PrivacyLink href='https://www.mavenmagnet.com/privacy-policy' target='_blank'>
          Privacy Policy
        </PrivacyLink>
      </PrivacyText>
      <RightSideFooter>
        &#xA9;
        <CompanyLogo src={FooterLogo}></CompanyLogo>
      </RightSideFooter>

    </FooterContainer>
      {isTourGuideActive && notMainPage && <TourGuide type="report" />}
    </FooterWrapperMain>
  )
}

export default Footer
